import { toHandlers as _toHandlers, unref as _unref, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["value", "placeholder"]

import { DatePicker } from 'v-calendar'
import { onBeforeUnmount, onMounted, ref } from 'vue'

import { registerPicker, soloPicker, unregisterPicker } from './openDatePickerPopover'

export default /*@__PURE__*/Object.assign({ inheritAttrs: false }, {
  __name: 'InlineDatePicker',
  props: { placeholder: { type: String, default: 'Select date' } },
  setup(__props) {



const picker = ref(null)
onMounted(() => registerPicker(picker.value))
onBeforeUnmount(() => unregisterPicker(picker.value))

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(_unref(DatePicker), _mergeProps({
    ref_key: "picker",
    ref: picker
  }, _ctx.$attrs, { popover: { visibility: 'click' } }), {
    default: _withCtx(({ inputValue, inputEvents }) => [
      _createElementVNode("input", _mergeProps({
        value: inputValue,
        readonly: "",
        placeholder: __props.placeholder,
        class: "inline sm:text-sm border border-gray-300 rounded-md px-2 py-1 cursor-pointer focus:outline-none focus:ring-1 focus:ring-brand-500 focus:border-brand-500 placeholder:text-gray-400"
      }, _toHandlers(inputEvents, true), {
        onClick: _cache[0] || (_cache[0] = $event => (_unref(soloPicker)(picker.value)))
      }), null, 16, _hoisted_1)
    ]),
    _: 1
  }, 16))
}
}

})